var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8025 1.14186C12.0628 0.881538 12.0628 0.459471 11.8025 0.199148C11.5421 -0.0611744 11.1199 -0.0611744 10.8596 0.199148L5.99973 5.05797L1.13991 0.199148C0.879534 -0.0611744 0.457381 -0.0611744 0.197004 0.199148C-0.063372 0.459471 -0.063372 0.881538 0.197004 1.14186L5.05683 6.00069L0.195282 10.8612C-0.0650939 11.1216 -0.0650942 11.5436 0.195282 11.8039C0.455658 12.0643 0.877812 12.0643 1.13819 11.8039L5.99973 6.9434L10.8613 11.8039C11.1217 12.0643 11.5438 12.0643 11.8042 11.8039C12.0646 11.5436 12.0646 11.1216 11.8042 10.8612L6.94264 6.00068L11.8025 1.14186Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClear);
export default __webpack_public_path__ + "static/media/clear.7e2964423c660b99cd81759a9fcabfc5.svg";
export { ForwardRef as ReactComponent };